/** @jsxImportSource @emotion/react */
import { useEffect, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Image } from "primereact/image";
import { urlBaseAPI } from "../../utils";

export default function ArchivoPreviewPage() {
  const { hash } = useParams();
  const [searchParams] = useSearchParams();
  const imagenRef = useRef(null);

  // `imagen` es sólo una pista de cómo mostrar el archivo (la manda
  // ArchivoPreview); sin ella la imagen se ve igual, dentro del iframe
  const esImagen = searchParams.get("imagen") === "1";

  // Las imágenes se abren directo en el visor, igual que con el click normal
  useEffect(() => {
    if (esImagen) {
      imagenRef.current?.show();
    }
  }, [esImagen]);

  // Esta pantalla no recibe restricciones por la URL a propósito: cualquier
  // flag que viajara acá se sacaría editando la barra de direcciones. Los
  // archivos que no se pueden descargar no se enlazan hasta acá.
  const previewUrl = `${urlBaseAPI()}/archivo/${hash}/preview`;

  return (
    <Card
      css={{
        marginTop: "1em",
        height: "calc(100vh - 120px)",
        ".p-card-body": { height: "100%", padding: 0 },
        ".p-card-content": { height: "100%", padding: 0 },
      }}
    >
      {esImagen ? (
        <div
          css={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            padding: "1rem",
            ".p-image": { maxWidth: "100%", maxHeight: "100%" },
            img: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" },
          }}
        >
          <Image
            ref={imagenRef}
            src={previewUrl}
            alt="Vista previa"
            preview
            css={{ display: "flex", height: "100%" }}
          />
        </div>
      ) : (
        <iframe
          src={previewUrl}
          title="Vista previa"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      )}
    </Card>
  );
}
